import { HugeiconsIconProps } from '@hugeicons/react'

export interface Step {
  id: string
  icon: HugeiconsIconProps['icon']
  type: 'form' | 'loading' | 'button' | 'popup_link'
  title: string
  description: string
  fields: Field[]

  linkTitle?: string
  link?: string

  buttonLabel?: string
}

export interface Option {
  value: string
  label: string
}

interface BaseField {
  type: string
  label: string
  name: string
  required: boolean
  description?: string
  placeholder?: string
}

export type TextField = BaseField & {
  type: 'text'
  inputType?: 'password' | 'text'
}

export type SelectField = BaseField & {
  type: 'select'
  multi: boolean
  options?: Option[]
}

export type Field = TextField | SelectField

export type OnSubmitFn = (data: object) => Promise<void>
export type OnReloadFn = () => void

export type StepComponentProps = {
  step: Step
  onSubmit: OnSubmitFn
  onReload: OnReloadFn
}

export function extractString(
  key: string,
  data?: Record<string, unknown>
): string {
  if (!data) return ''
  if (!(key in data)) return ''
  if (typeof data[key] !== 'string') return ''
  return data[key]
}

export function extractOptions(
  key: string,
  data?: Record<string, unknown>
): Option[] {
  if (!data) return []
  if (!(key in data)) return []
  if (!Array.isArray(data[key])) return []
  return data[key].filter(isOption)
}

export function isOption(opt: unknown): opt is Option {
  if (!opt || typeof opt !== 'object') return false
  if (!('value' in opt) || typeof opt.value !== 'string') return false
  if (!('label' in opt) || typeof opt.label !== 'string') return false
  return true
}
